export enum ResultAddDevice{
    AddNotificationDevice,
}